import { useI18n } from 'vue-i18n'
import { useFeatureStore } from '@/stores/featureStore'
import { createContentState } from './state'
import { createGenerateFromTrend } from './methods/generate-from-trend'
import { createGenerateManualContent } from './methods/generate-manual-content'
import { createRegenerateContent } from './methods/regenerate-content'
import { contentService } from '../../services/content/content-service'

/**
 * Composable for content generation
 * @returns {Object} Content generation state and methods
 */
export function useContentGeneration() {
  const { t } = useI18n()
  const featureStore = useFeatureStore()
  
  // Create state
  const state = createContentState()
  
  // Create methods
  const generateFromTrend = createGenerateFromTrend(state)
  const generateManualContent = createGenerateManualContent(state)
  const regenerateContent = createRegenerateContent(
    state,
    (data, assetStore) => generateFromTrend(data, assetStore, { t, featureStore }),
    (data, assetStore) => generateManualContent(data, assetStore, { t, featureStore })
  )
  
  // Create handlers using content service
  const handleCancel = () => contentService.cancelGeneration(state, t)
  const handleResetContent = () => contentService.resetContent(state)
  
  // Return public API
  return {
    // State
    isGenerating: state.isGenerating,
    generatedContent: state.generatedContent,
    previousContent: state.previousContent,
    lastGenerationParams: state.lastGenerationParams,
    
    // Methods
    generateFromTrend: (data, assetStore) => 
      generateFromTrend(data, assetStore, { t, featureStore }),
    generateManualContent: (formData, assetStore) => 
      generateManualContent(formData, assetStore, { t, featureStore }),
    regenerateContent: (assetStore) => regenerateContent(assetStore, t),
    cancelGeneration: handleCancel,
    resetContent: handleResetContent,
  }
}
